<script>
  import TrendChart from './TrendChart.vue';

  export default {
    name: 'AverageSalePriceTrends',
    extends: TrendChart,
    data() {
      return {
        chartId: 'averageSalePriceTrends',
        propertyName: 'avg_selling_price_post_disc',
        label: 'Net ASP',
        curYearColor: '#824A9E',
        prevYearColor: '#FF584C',
        labelFormat: ',.0f',
      };
    },
  };
</script>
